export default "__VITE_ASSET__47301acd__"